import { combineReducers } from "redux";
import userReducer from "./user/userReducer";
import tradeReducer from "./trade/tradeReducer";
import authReducer from "./user/auth/authReducer";
import bookReducer from "./book/bookReducer";

const rootReducer = combineReducers({
  user: userReducer,
  book: bookReducer,
  auth: authReducer,
  trade: tradeReducer,
});

export default rootReducer;
